<template>
  <tr
    class="subtable"
    :id="uniqueStoreName"
    :ref="uniqueStoreName"
  >
    <td :colspan="colspan">
      <webon-table
        v-bind="subtableProps"
        v-if="isMounted"
        :module-name="subtableStore.name"
        shrink-table
      />
      <template v-else>
        <div class="loading-data">
          Cargando...
          <div class="loader loader-circle"></div>
        </div>
      </template>
    </td>
  </tr>
</template>

<script>
import WebonTable from "@/components/global/webon/webon-table/WebonTable.vue";

export default {
  name: "subtable",
  components: {
    WebonTable,
  },
  props: {
    parentStoreName: { type: String, default: "" },
    subtableProps: { type: Object, default: () => null },
    subtableStore: {
      name: { type: String, default: "" },
      store: { type: Object, default: () => null },
    },
    rowIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isMounted: false,
      uniqueStoreName: "",
    };
  },
  mounted() {
    this.$store.registerModule(
      this.subtableStore.name,
      this.subtableStore.store()
    );
    this.isMounted = true;
  },
  methods: {
    destroyStore() {
      try {
        this.isMounted = false;
        this.$store.unregisterModule(this.subtableStore.name);
      } catch (err) {
        this.$log.error(`Error unregistering module. More details: ${err}`);
      }
    },
  },
  computed: {
    parentStore() {
      return this.$store.state[this.parentStoreName];
    },
    colspan() {
      return this.parentStore.table.columnsDefinition.length || 0;
    },
  },
};
</script>
